const monthListShort = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const monthListLong = ['January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'];

export function formatDateWithMonthName(dateIsoString: string) {
    const date = new Date(dateIsoString);
    return `${('0' + date.getDate()).slice(-2)} ${monthListShort[date.getMonth()]} ${date.getFullYear()}`;
}

export function fullDateTime(dateIsoString: string) {
    const date = new Date(dateIsoString);
    return `${('0' + date.getDate()).slice(-2)} ${monthListLong[date.getMonth()]}
    ${date.getFullYear()} ${('0' + date.getHours()).slice(-2)}:${('0' + date.getMinutes()).slice(-2)}`;

}
